import { getDecimalFormat } from "helpers/getNumberFormats";
import { setXlsxRow, setXml } from "redux/actions/gasMovDataXLSX/gasMovDataXLSXActions";
import { useDispatch, useSelector } from "react-redux";
import { useSearch } from "hooks/useSearch";
import { useState } from "react";
import { formatCustomDate } from "helpers/dateTools"
import { generateRandomID } from "helpers/generateRandomID";
import moment from "moment";

const toNoGN3 = (obj, setSnackbar, fileName, stationsList, validFile) => {
  const objUpperCase = {}
  Object.keys(obj).forEach(key => objUpperCase[key.toUpperCase()] = obj[key])
  if(!moment(objUpperCase.FECHAYHORATRANSACCION).isValid()) {
    validFile.valid = false
    return setSnackbar(`${fileName} - Errores de Formato de fecha no es una plantilla valida`)
  }
  if(stationsList.filter(station => station.id === objUpperCase?.ID).length !== 1) {
    validFile.valid = false
    return setSnackbar(`${fileName} - Errores en los id's de plantas no es una plantilla valida`)
  }

  if(!/\b[A-Z]{2}[/]\d{5}[/][A-Z]{3,4}[/][A-Z]{2,4}[/]\d{4}\b/.test(objUpperCase?.PERMISOCRE)) {
    validFile.valid = false
    return setSnackbar(`${fileName} - Errores de Formato del permiso no es una plantilla valida`)
  }

  return {
    uuid: objUpperCase?.CFDI,
    rfcLegalEntity: objUpperCase?.RFCEMPRESA,
    station: objUpperCase?.PLANTA,
    permission: objUpperCase?.PERMISOCRE,
    rfcCustomer: objUpperCase?.RFCCLIENTEOPROVEEDOR,
    customer: objUpperCase?.NOMBRECLIENTEOPROVEEDOR,
    price: getDecimalFormat(objUpperCase?.PRECIOVENTAOCOMPRAOCONTRAP),
    date: formatCustomDate(objUpperCase?.FECHAYHORATRANSACCION, '-'),
    quantity: getDecimalFormat(objUpperCase?.VALORNUMERICO),
    measurementUnit: objUpperCase?.UM,
  }
}

const toSat = (obj, setSnackbar, fileName, validFile) => {
  const objUpperCase = {}
  Object.keys(obj).forEach(key => objUpperCase[key.toUpperCase()] = obj[key])
  if(!moment(objUpperCase.FECHAEMISION).isValid() && !moment(objUpperCase.FECHACERTIFICACIONSAT).isValid()) {
    validFile.valid = false
    return setSnackbar(`${fileName} - Errores en Formato de fecha no es una plantilla valida`)
  }
  return {
    uuid: objUpperCase?.UUID,
    rfcIssuer: objUpperCase?.RFCEMISOR,
    issuer: objUpperCase?.NOMBREEMISOR,
    rfcCustomer: objUpperCase?.RFCRECEPTOR,
    customer: objUpperCase?.NOMBRERECEPTOR,
    rfcPac: objUpperCase?.RFCPAC,
    invoiceDate: formatCustomDate(objUpperCase?.FECHAEMISION, '-'),
    certificationDate: formatCustomDate(objUpperCase?.FECHACERTIFICACIONSAT, '-'),
    amount: getDecimalFormat(objUpperCase?.MONTO),
    movementType: objUpperCase?.EFECTOCOMPROBANTE,
    status: objUpperCase?.ESTATUS,
    cancellationDate: objUpperCase?.FECHACANCELACION ? formatCustomDate(objUpperCase.FECHACANCELACION) : 'NO APLICA',
  }
}


export const useXlsxControls = () => {
  const dispatch = useDispatch()
  const {setSnackbar} = useSearch()
  const [loading, setLoading] = useState(false)
  const {stationsList} = useSelector(({ companies }) => companies);
  
  const checkForNullOrUndefined = (obj) => {
    for (let key in obj) {
      if (obj[key] === null || obj[key] === undefined) return false;
    }
    return true;
  }
  
  
  const processXLSX = (file, type=true) => {
    try {
      setLoading(true)
      if (!file) {
        setSnackbar('Error con el archivo')
        setLoading(false)
        return
      }
      const extension = file.name;
      if (!extension.includes('xlsx') && !extension.includes('xls')) {
        setSnackbar('No es una hoja de cálculo válida')
        setLoading(false)
        return
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const worker = new Worker(new URL('./xlsxWorker.js', import.meta.url));
          worker.onmessage = (event) => {
            try {
              const { success, data } = event.data;
              if (!success) {
                setSnackbar('Error al procesar el archivo')
                setLoading(false)
                worker.terminate()
                return
              }

              let validFile = {
                id: generateRandomID(6),
                file: file,
                fileName: file.name,
                rows: [],
                valid: true
              }

              for (const obj of data) {
                if (!validFile.valid) break
                let row = type ? toNoGN3(obj, setSnackbar, file.name, stationsList, validFile) : toSat(obj, setSnackbar, file.name, validFile)
                if (!validFile.valid) break
                if(!checkForNullOrUndefined(row)) {
                  validFile.valid = false
                  setSnackbar(`${file?.name} - Celdas vacias, no es una plantilla valida`)
                  break
                }
                validFile.rows.push(row)
              }

              if(validFile.valid) dispatch(setXlsxRow(validFile))
              setLoading(false)
              worker.terminate()
            } catch (err) {
              setSnackbar('Error al procesar el archivo')
              setLoading(false)
              worker.terminate()
            }
          };
          worker.onerror = () => {
            setSnackbar('Error al procesar el archivo')
            setLoading(false)
            worker.terminate()
          };
          worker.postMessage(e.target.result);
        } catch (err) {
          setSnackbar('Error al procesar el archivo')
          setLoading(false)
        }
      };
      reader.onerror = () => {
        setSnackbar('Error al procesar el archivo')
        setLoading(false)
      };
      reader.readAsArrayBuffer(file);
    } catch (error) {
      setSnackbar('Error al procesar el archivo')
      setLoading(false)
    }
  }

  const processXML = (file) => {
    try {
      setLoading(true)
      if (!file) {
        setSnackbar('Error con el archivo')
        setLoading(false)
        return
      }
      const extension = file.name;
      if (!extension.includes('xml')) {
        setSnackbar('No es un xml válido')
        setLoading(false)
        return
      }
      dispatch(setXml(file))
      setLoading(false)
    } catch (error) {
      setSnackbar('Error al procesar el archivo')
      setLoading(false)
    }
  }
  return {loading, processXLSX, processXML}
}
